import React, {useEffect,useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {fetchSrpDataThunk} from './redux/thunks';
import SearchWidget from './../../../shared/pages/StoriesTestPage/SrpPage/SearchWidget/SearchWidget';
import {commonSelector} from './../Common/redux/selectors';
import {pushEcommerceGAEvent} from 'ga-utils';
import {useHistory} from 'react-router-dom';
import {prepareSRPURL,replaceSRPUrlState,getQueryString,fillSRPDataFromURL} from './../Common/Utils'
import {nextDayBusSelector,alternateRouteSelector,srpRawDataSelector,dataLoadingSelector,moveToAlternateRoutePageSelector} from './redux/selectors'
import {updateJourneyParams} from './../Common/redux/actions'

import AlternateRoutes from './AlternateRoutes/AlternateRoutes'
import AlternateDatesUI from './../../pages/AlternateDates/AlternateDatesUI'  
import dateFormat from 'dateformat';
import getDateObj from './../../utils/GetDateObj';
import * as S from './../../../shared/pages/StoriesTestPage/StoriesTestPage.styles';
import {getInitSelectedFilters} from './Utils';
import NoBusFoundUI from './../../pages/NoBusFound//NoBusFoundUI';
import format_dateObj from './../../utils/FormatDateObj';
import dateformat from 'dateformat';
import format_BusQueryDate from './../../utils/QueryDateFormat';
import {toggleAlternateRoutePage} from './redux/actions'
import {pushga} from 'ga-utils'
import {AlternateRouteGAEvents} from './../../config/ga-config'
import {Helmet} from 'react-helmet';
function AlternateRoutesUI(){


    const history = useHistory();
    const dispatch = useDispatch();
    const commonData = useSelector(commonSelector);
    const alternateRoutes = useSelector(alternateRouteSelector);
    const nextDayBuses = useSelector(nextDayBusSelector)
    const {rawData} = useSelector(srpRawDataSelector);
    const isDataLoading = useSelector(dataLoadingSelector);
    const isDataPresent =  rawData && rawData.buses && rawData.buses.length;
    const moveToAlternateRoutePage = useSelector(moveToAlternateRoutePageSelector)
  
    const{src,dest,src_vid,dest_vid,doj,dojObj,src_name,dest_name} = commonData;
    const [selectedFilters, setSelectedFilters] = useState(getInitSelectedFilters());
    let tommorrowDate = format_dateObj({keyName:'alternatePage',value:dateformat(dojObj,'yyyy-mm-dd')})['alternatePageRaw']
    if(dojObj){
         tommorrowDate.setDate(dojObj.getDate() + 1);
    }
 function updatePage({src,dest,src_id,dest_id,doj,dojObj}){
  let journeyParamsObj = {
    src,
    dest,
    src_vid:src_id,
    dest_vid:dest_id,
    doj,
    journeyType: 'onw',
    flavour: 'dweb',
    dojObj,
    src_name:src,
    dest_name:dest,
  };
  dispatch(updateJourneyParams(journeyParamsObj))
   
//   dispatch(
//     fetchSrpDataThunk({
//       src: src,
//       dest: dest,
//       src_id,
//       dest_id,
//       doj:doj,
//       src_name:src,
//       dest_name:dest
//     }),
//   );
    dispatch(toggleAlternateRoutePage(false));
    const srpURL = prepareSRPURL({src_name:src,dest_name:dest,selectedDate:dojObj,src_vid:src_id,dest_vid:dest_id});
    
    history.push(srpURL);
    replaceSRPUrlState({
      history,
      search:window.location.search,
      keyName:'bid',
      inputValues:{
        src_name:src,
        dest_name:dest,
        src_vid:src_id,
        dest_vid:dest_id,
        selectedDate:dojObj
     
      }

   })
}
useEffect(() => {
    if(!moveToAlternateRoutePage){
        fillSRPDataFromURL(dispatch,fetchSrpDataThunk,window.location.search)
     
      }else{
        dispatch(toggleAlternateRoutePage(false));
        
      }
      try{
        pushEcommerceGAEvent({
             virtualPage: history.location.pathname + history.location.search,
             pageViewEvents: {
              cdBusSearchOrigin: src,
              cdBusSearchDestination: dest,
              cdBusSearchDepartureDate: dojObj,
              cdSubCatQuery: 'OneWay',
              cdCatQuery: 'bus-domestic'
            }
           });
          }catch(err){
            console.warn("issue in page view send")
          }
    return () => {
   
          dispatch(toggleAlternateRoutePage(false));
        
   }
  
  }, [])
  
    return (
      <>
      <Helmet
        title={"Bus Booking - Online Bus Ticket Booking of all Bus types at best prices"}
        meta={
        [{name: 'description', content:"Book Bus Tickets online with Goibibo. Bus Ticket Booking for AC Volvo, Sleeper, Luxury and other buses with attractive offers. Get confirmed Bus Reservation tickets at best prices."},
            {name: 'keywords', content:"Goibibo, online bus booking, book bus online, bus booking site, Goibibo buses"},
            {property: 'og:title', content:"Bus Booking - Online Bus Ticket Booking of all Bus types at best prices"},
            {property:'og:description',content:"Book Bus Tickets online with Goibibo. Bus Ticket Booking for AC Volvo, Sleeper, Luxury and other buses with attractive offers. Get confirmed Bus Reservation tickets at best prices."},
            {property:'og:image',content:'https://gos3.ibcdn.com/bus-default-1489655303.jpg'},
       
        ]
        }
     
      />
   
        <S.HomeBodyWrapperSection id="srpCardLayout">
    
        <SearchWidget setSelectedFilters={setSelectedFilters} srcInputBoxId ={"autosuggestBusSRPSrcAlternate"} destInputBoxId={"autosuggestBusSRPDestAlternate"} updateSearchCB={(data)=>{
          const {selectedDate,src_name,dest_name,src_vid,dest_vid} = data;
          const srpURL = prepareSRPURL({src_name,dest_name,selectedDate,src_vid,dest_vid});
          dispatch(toggleAlternateRoutePage(false));
         history.push(srpURL);
         pushga({
            event: AlternateRouteGAEvents.actions.updatesearch,
            eventCategory: AlternateRouteGAEvents.category,
            eventAction: AlternateRouteGAEvents.actions.updatesearch
          });
            
        }}/>
        <S.SearchBlockOuterWrapper >

<S.AlternatePageBody>
        <NoBusFoundUI searchedDateHeading={dateFormat(dojObj,'mmm dd')} searchedDateMsg={dateFormat(dojObj,'d mmm')}></NoBusFoundUI>
        {(nextDayBuses && nextDayBuses.no_of_bus && nextDayBuses.no_of_bus > 0 ) ?
        <AlternateDatesUI 
        nextDate={tommorrowDate ? dateFormat(tommorrowDate,'ddd, dd mmm') :''}
        nextDateBusCount={nextDayBuses && nextDayBuses.no_of_bus}
        onClickCb={()=>{
 
         const currentDate = dojObj;
     
         currentDate.setDate(dojObj.getDate() + 1);
         updatePage({src,dest,src_id:src_vid,dest_id:dest_vid,doj:dateFormat(currentDate,'yyyymmdd'),dojObj:currentDate})
         pushga({
            event: AlternateRouteGAEvents.actions.nextdate,
            eventCategory: AlternateRouteGAEvents.category,
            eventAction: AlternateRouteGAEvents.actions.nextdate
          });
        }}
        ></AlternateDatesUI> :null}
        <AlternateRoutes alternateRoutes={alternateRoutes} searchedDateHeading={dateFormat(dojObj,'mmm dd')} searchedSrcName ={src_name} searchedDestName={dest_name} searchedDate={dojObj} onClickCb={(routeInfo)=>{
        const {
         dest,
         dest_vid,
         src,
         src_vid
         } = routeInfo;
       
         updatePage({src,dest,src_id:src_vid,dest_id:dest_vid,doj,dojObj})
    
         pushga({
            event: AlternateRouteGAEvents.actions.alternateroute,
            eventCategory: AlternateRouteGAEvents.category,
            eventAction: AlternateRouteGAEvents.actions.alternateroute
          });
         }}></AlternateRoutes> 
         </S.AlternatePageBody>
        </S.SearchBlockOuterWrapper>
      </S.HomeBodyWrapperSection>
       </>
       
       ) 



}
export default AlternateRoutesUI;

